import { DialogService } from '@eforall/dashboard';
import { EventAddDialog } from '../../../../../../../ui/widget';

import { GridButton } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';
import { SelectEventTypeDialog } from '../select-event-type-dialog/select-event-type.dialog';


export function getButtons(dialogService: DialogService, accAreaService: AcceleratorAreaService) {
	const buttons: GridButton[] = [
		{
			iconClass: 'fa-plus',
			label: 'Add Event',
			execute: async () => {

				const result = await dialogService.showCustom(SelectEventTypeDialog, { data: {} }, 450, 300);

				if (result.id == 'select' && result.callbackResult) {

					console.log('Selected Event Type ID:', result.callbackResult);

					const selectedEventTypeId = result.callbackResult;
					await dialogService.showCustom(EventAddDialog, { data: { eventTypeId: selectedEventTypeId, languageId: accAreaService.data()!.acc.languageId, accId: accAreaService.data()!.acc.accId } }, 900, 700);
					await accAreaService.reloadData();
				}

			}
		},
	];

	return buttons;
}